import { render, staticRenderFns } from "./thenDiaolg.vue?vue&type=template&id=000cb1b6&scoped=true"
import script from "./thenDiaolg.vue?vue&type=script&lang=js"
export * from "./thenDiaolg.vue?vue&type=script&lang=js"
import style0 from "./thenDiaolg.vue?vue&type=style&index=0&id=000cb1b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000cb1b6",
  null
  
)

export default component.exports